import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import { SET_NEWS_DATA } from '../socket/constants';
import { FETCH_NEWS_SUCCESS } from './constants';

const LIST_LIMIT = 200;
const initialState = fromJS([]);

export default handleActions({
	[FETCH_NEWS_SUCCESS]: (state: any, { payload }: any) => fromJS(payload.data),
	[SET_NEWS_DATA]: (state: any, { payload }: any) => state.unshift(payload.data).slice(0, LIST_LIMIT),
}, initialState);
